import type { AlertIconVariant } from "@mm/metx-design-system";
import type { AlertNotification } from "./api";

export function alertIconVariant(severity: AlertNotification["severity"]): AlertIconVariant {
  return severity === "unknown" || severity === "default" ? "medium" : severity;
}
